import { IAdFoxBannerOnLoadData } from '@cian/adfox-component';
import { useDidMount } from '@cian/valuation-utils-component';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { useSelector } from 'react-redux';

import { AdfoxBanner } from '../../../components/AdfoxBanner';
import { useConstant } from '../../../hooks/useConstant';
import { selectIsAgent } from '../../../selectors';
import { useAdfoxBannerActions } from '../hooks/useAdfoxBannerActions';
import { useAdfoxPuids } from '../hooks/useAdfoxPuids';

const ADFOX_PARAMETERS = {
  p1: 'bvknz',
  p2: 'y',
};

export const StretchBannerContainer: React.FC = () => {
  const adfoxStretchBannerElement = useConstant<HTMLElement | null>(() => {
    if (process.env.IS_BROWSER_BUILD) {
      return document.getElementById('adfox-stretch-banner');
    }

    return null;
  });

  const isAgent = useSelector(selectIsAgent);
  const adfoxPuids = useAdfoxPuids();
  const adfoxParameters = React.useMemo(
    () => ({
      ...adfoxPuids,
      ...ADFOX_PARAMETERS,
    }),
    [adfoxPuids],
  );
  const { onClick, onLoad } = useAdfoxBannerActions();

  const handleLoad = React.useCallback(
    ({ bundleParams: { bannerId } }: IAdFoxBannerOnLoadData) => {
      onLoad(bannerId);
    },
    [onLoad],
  );

  useDidMount(() => {
    if (adfoxStretchBannerElement) {
      adfoxStretchBannerElement.style.minHeight = '0';
    }
  });

  if (adfoxStretchBannerElement == null) {
    return null;
  }

  return ReactDOM.createPortal(
    <AdfoxBanner
      disableYan={isAgent}
      params={adfoxParameters}
      onClick={onClick}
      onLoad={handleLoad}
      minHeight="200px"
      width="100%"
    />,
    adfoxStretchBannerElement,
  );
};
